"use strict";

document.addEventListener("DOMContentLoaded", () => {
  const root = document.documentElement;
  const body = document.body;
  const increase = document.getElementById("increase-font");
  const reset = document.getElementById("reset-font");
  const decrease = document.getElementById("decrease-font");
  const contrast = document.getElementById("toggle-contrast");
  const status = document.getElementById("accessibility-status");
  const scales = [87.5, 100, 112.5, 125, 137.5, 150];

  const readSetting = (key, fallback) => {
    try {
      return window.localStorage.getItem(key) ?? fallback;
    } catch (_error) {
      return fallback;
    }
  };

  const saveSetting = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (_error) {
      // The controls still work when storage is unavailable.
    }
  };

  const announce = (message) => {
    if (!status) return;
    status.textContent = "";
    window.setTimeout(() => {
      status.textContent = message;
    }, 20);
  };

  const applyScale = (scale, shouldAnnounce = true) => {
    const safeScale = scales.includes(scale) ? scale : 100;
    root.style.fontSize = `${safeScale}%`;
    root.dataset.fontScale = String(safeScale);
    saveSetting("ebb-font-scale", String(safeScale));
    if (shouldAnnounce) announce(`Schriftgröße ${safeScale} Prozent`);
  };

  const currentScale = () => Number(root.dataset.fontScale || 100);
  const moveScale = (direction) => {
    const currentIndex = Math.max(0, scales.indexOf(currentScale()));
    const nextIndex = Math.min(scales.length - 1, Math.max(0, currentIndex + direction));
    applyScale(scales[nextIndex]);
  };

  const applyContrast = (enabled, shouldAnnounce = true) => {
    body.classList.toggle("high-contrast", enabled);
    contrast?.setAttribute("aria-pressed", String(enabled));
    saveSetting("ebb-high-contrast", enabled ? "1" : "0");
    if (shouldAnnounce) announce(enabled ? "Kontrastmodus eingeschaltet" : "Kontrastmodus ausgeschaltet");
  };

  applyScale(Number(readSetting("ebb-font-scale", "100")), false);
  applyContrast(readSetting("ebb-high-contrast", "0") === "1", false);

  increase?.addEventListener("click", () => moveScale(1));
  decrease?.addEventListener("click", () => moveScale(-1));
  reset?.addEventListener("click", () => applyScale(100));
  contrast?.addEventListener("click", () => applyContrast(!body.classList.contains("high-contrast")));
});
